import graphql from 'babel-plugin-relay/macro'
import { useLazyLoadQuery } from 'react-relay/hooks'

import { ViewedUserNameQuery } from './__generated__/ViewedUserNameQuery.graphql'

const query = graphql`
  query ViewedUserNameQuery($userId: ID!) {
    viewer {
      user(id: $userId) {
        firstName
        lastName
        email
      }
    }
  }
`

type Props = {
  /** The ID of the user whose tenant is being viewed by an admin. */
  userId: string
  children: (name?: string) => React.ReactNode
}

/**
 * Fetches the viewed user's name (or email) and passes it to its children.
 * Used to label the tenant breadcrumb when an admin views another user's
 * personal tenant.
 */
export default function ViewedUserName({ userId, children }: Props) {
  const { viewer } = useLazyLoadQuery<ViewedUserNameQuery>(query, { userId })
  const user = viewer.user

  const name = user
    ? `${user.firstName} ${user.lastName}`.trim() || user.email
    : undefined

  return <>{children(name)}</>
}
